export default class Form {
    
    constructor()
    {
        Form.select();
        Form.dynamicLabel();
        Form.initAvizi();
    }
    
    static select()
    {
        $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
    }
    
    /* Dynamic label
     /* ============================================= */
    static dynamicLabel()
    {
        const $input = $( ".wpet-select-item .formGroup--text input, .formGroup--textarea textarea, .formGroup--select select, .formGroup--phone input, .formGroup--number input, .formGroup--date input, .formGroup--email input, #newsletter-field, .wpSearchFormItem--input" );
        
        $input.each( function () {
            if ( $( this ).val() && $( this ).val().length != 0 || $( this ).attr( 'placeholder' ) !== undefined ) {
                
                $( this ).closest( '.formGroup' ).find( 'label' ).addClass( "label-active" );
            }
        } );
        
        $( document ).on( 'focusin', $input, function ( e ) {
            $( e.target ).closest( '.formGroup' ).find( 'label' ).addClass( "label-active" );
        } );
        
        $( document ).on( 'focusout', $input, function ( e ) {
            if ( $( e.target ).val() && $( e.target ).val().length == 0 || !$( e.target ).val() ) {
                $( e.target ).closest( '.formGroup' ).find( 'label' ).removeClass( "label-active" );
            }
        } );
    }
    
    static initAvizi()
    {
        if ( $( "#frame-avizi-widget2" ).length ) {
            
            $( "#frame-avizi-widget2" ).aviziCampagneWidget( {
                                                                 url: "https://app.avizi.fr",
                                                                 widget: 1714,
                                                                 key: "9d2ce5eac8706fe9939e38d91e5fb846",
                                                                 language: "fr",
                                                                 entity: "Office de Tourisme du Pays d'Angoulême"
                                                             } );
        }
    }
}